import * as React from "react";
import { forwardRef } from "react";
const InformationSVG = (props, ref) => React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", ref: ref, ...props },
    React.createElement("g", { clipPath: "url(#prefix__clip0_879_27)" },
        React.createElement("path", { d: "M8 6.5a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0v-4a1 1 0 0 1 1-1M8 5.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2" }),
        React.createElement("path", { fillRule: "evenodd", d: "M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-6a6 6 0 1 0 0 12A6 6 0 0 0 8 2", clipRule: "evenodd" })),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "prefix__clip0_879_27" },
            React.createElement("path", { d: "M0 0h16v16H0z" }))));
const ForwardRef = forwardRef(InformationSVG);
export default ForwardRef;
//# sourceMappingURL=Information.js.map